module.exports = __webpack_public_path__ + "987e1359999d933bdc186981bfadca4d.mp4";